const classPrefix = 'header';
const dataPrefix = 'data-header';
const container = document.querySelector(`[${dataPrefix}]`);
if (container) {
    header();
}

export function header() {
    const burgerBtn = container.querySelector('[data-header-menu-open]');
    const burgerIcon = burgerBtn.querySelector(`.${classPrefix}__mobile-menu-wrapper-burger`);
    const menuList = container.querySelector(`.${classPrefix}__menu-list`);
    const menuItems = Array.from(container.querySelectorAll(`.${classPrefix}__menu-list-item`));
    const closeBtns = Array.from(container.querySelectorAll(`[${dataPrefix}-body-menu-close]`));
    const breakpoint = window.matchMedia('(max-width: 767px)');

    // Тоггл мобильного меню
    burgerBtn.addEventListener('click', e => {
        e.stopPropagation();
        burgerIcon.classList.toggle('is-open');
        menuList.classList.toggle(`${classPrefix}__menu-list--open`);
        closeAllSubmenus();
    });

    // Функция закрытия всех подменю
    function closeAllSubmenus() {
        menuItems.forEach(item => {
            item.querySelector(`.${classPrefix}__menu-list-item-body--active`)?.classList.remove(`${classPrefix}__menu-list-item-body--active`);
            item.querySelector(`.${classPrefix}__menu-list-item-title--active`)?.classList.remove(`${classPrefix}__menu-list-item-title--active`);
        });
    }

    // Обработка клика по айтемам (для мобилки и десктопа)
    menuItems.forEach(item => {
        const title = item.querySelector(`.${classPrefix}__menu-list-item-title`);
        const submenu = item.querySelector(`.${classPrefix}__menu-list-item-body`);
        const id = title.getAttribute(`${dataPrefix}-body-menu-open`);

        title.addEventListener('click', e => {
            e.stopPropagation();
            if (!submenu) return;

            const isActive = submenu.classList.contains(`${classPrefix}__menu-list-item-body--active`);
            closeAllSubmenus();

            if (!isActive) {
                title.classList.add(`${classPrefix}__menu-list-item-title--active`);
                submenu.classList.add(`${classPrefix}__menu-list-item-body--active`);
            }
        });
    });

    // Кнопки "назад" внутри моб. подменю
    closeBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.stopPropagation();
            const id = btn.getAttribute(`${dataPrefix}-body-menu-close`);
            const parentSub = container.querySelector(`[${dataPrefix}-body-menu="${id}"]`);
            const parentTitle = container.querySelector(`[${dataPrefix}-body-menu-open="${id}"]`);
            parentSub.classList.remove(`${classPrefix}__menu-list-item-body--active`);
            parentTitle.classList.remove(`${classPrefix}__menu-list-item-title--active`);
        });
    });

    // Закрываем всё при клике вне header
    document.addEventListener('click', e => {
        if (!container.contains(e.target)) {
            // моб. меню
            burgerIcon.classList.remove('is-open');
            menuList.classList.remove(`${classPrefix}__menu-list--open`);
            // подменю
            closeAllSubmenus();
        }
    });

    // Сбрасываем состояние при ресайзе
    window.addEventListener('resize', () => {
        burgerIcon.classList.remove('is-open');
        menuList.classList.remove(`${classPrefix}__menu-list--open`);
        closeAllSubmenus();
    });
}
